






























































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import DeviceTypeService from '@/services/devicetype.service';
import {DeviceType} from '@/types';
import {Action, Getter} from 'vuex-class';
import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';

const BUNDLE_LABELS: {[key: string]: string} = {
  '0_2@SENSOR_COMMON': '2 messages/day',
  '3_24@SENSOR_COMMON': '24 messages/day',
  '25_144@SENSOR_COMMON': '144 messages/day',
};

@Component({
  components: {CancelButton, ConfirmButton},
})
export default class NetmoreConfiguration extends Vue {
  @Action private addToastErrorMessage: any;
  @Getter private hasPermission: any;
  @Prop() private deviceType!: DeviceType;
  @Prop() private netmoreConfiguration!: string;

  private editing = false;
  private saving = false;
  private selection: string | null = null;

  @Watch('netmoreConfiguration', {immediate: true})
  private onConfigChange() {
    this.selection = this.netmoreConfiguration;
  }

  private get selectionLabel() {
    return this.selection ? (BUNDLE_LABELS[this.selection] || this.selection) : 'Default (144 messages/day)';
  }

  private startEdit() {
    this.selection = this.netmoreConfiguration;
    this.editing = true;
  }

  private cancelEdit() {
    this.selection = this.netmoreConfiguration;
    this.editing = false;
  }

  private async save() {
    this.saving = true;
    try {
      if (this.selection) {
        await DeviceTypeService.updateOrganisationDeviceTypeConfiguration(this.deviceType.id, this.selection);
      }
      this.$emit('update:netmore-configuration', this.selection);
      this.editing = false;
    } catch (e) {
      const err = e as Error;
      this.addToastErrorMessage(err.message);
    } finally {
      this.saving = false;
    }
  }
}
